import React from "react";
import { Link } from "react-router-dom";
import { Nav, Navbar, Container, Button, NavDropdown } from "react-bootstrap";
import { useLogoutUserMutation } from "../services/appApi";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import logo from "../assets/logo.png";
import { getOptimizedAvatar } from "../utils/imageOptimization";
import { useNotifications } from "../context/NotificationContext";
function Navigation() {
  const user = useSelector((state) => state.user);
  const [logoutUser] = useLogoutUserMutation();
  const { unreadCount } = useNotifications();
  async function handleLogout(e) {
    e.preventDefault();
    try {
      await logoutUser(user);
    } catch (error) {
      console.warn("Backend logout failed (server might be down). Logging out locally.", error);
    } finally {
      // remove token from local storage
      localStorage.removeItem("userToken");
      // clear the Redux persisted state so the user is truly logged out
      localStorage.removeItem("persist:root");
      // redirect to home page
      window.location.replace("/");
    }
  }
  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <LinkContainer to="/">
          <Navbar.Brand>
            <img src={logo} style={{ width: 50, height: 50 }} />
          </Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {!user && (
              <LinkContainer to="/login">
                <Nav.Link>Login</Nav.Link>
              </LinkContainer>
            )}
            <LinkContainer to="/chat">
              <Nav.Link>Chat</Nav.Link>
            </LinkContainer>
            {user && (
              <NavDropdown
                title={
                  <>
                    <img
                      src={getOptimizedAvatar(user.picture, 30)}
                      style={{
                        width: 30,
                        height: 30,
                        marginRight: 10,
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                    {user.name}
                  </>
                }
                id="basic-nav-dropdown"
              >
                <LinkContainer to="/">
                  <Nav.Link>Home</Nav.Link>
                </LinkContainer>
                {/* <LinkContainer to="/tournament">
                  <Nav.Link>Tournament</Nav.Link>
                </LinkContainer> */}
                <LinkContainer to="/calendar">
                  <Nav.Link>Calendar</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/notifications">
                  <Nav.Link id="nav-notifications-link">
                    Notifications
                    {unreadCount > 0 && (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginLeft: 7,
                          minWidth: 18,
                          height: 18,
                          padding: "0 5px",
                          borderRadius: 9,
                          background: "#007AFF",
                          color: "#fff",
                          fontSize: 11,
                          fontWeight: 700,
                          lineHeight: 1,
                        }}
                        aria-label={`${unreadCount} unread notifications`}
                      >
                        {unreadCount > 99 ? "99+" : unreadCount}
                      </span>
                    )}
                  </Nav.Link>
                </LinkContainer>
                <LinkContainer to="/profile">
                  <Nav.Link>Profile</Nav.Link>
                </LinkContainer>
                {user && user.role === "admin" && (
                  <LinkContainer to="/admin">
                    <Nav.Link>Admin Panel</Nav.Link>
                  </LinkContainer>
                )}

                {/* <NavDropdown.Item href="#action/3.3">
                  Something
                </NavDropdown.Item> */}

                <NavDropdown.Item>
                  <Button variant="danger" onClick={handleLogout}>
                    Logout
                  </Button>
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
